import type { ReactNode } from 'react';

/** Schrittanzeige eines Ablaufs: erledigte Schritte sind abgehakt, der aktuelle ist markiert. Auf dem Handy steht nur die Nummer und der Titel des aktuellen Schritts. */
export function Stepper({ steps, current }: { steps: string[]; current: number }) {
  return (
    <ol className="wiz-steps" aria-label="Ablauf">
      {steps.map((title, i) => {
        const state = i < current ? 'done' : i === current ? 'current' : 'todo';
        return (
          <li key={title} className={`wiz-step wiz-step--${state}`} aria-current={state === 'current' ? 'step' : undefined}>
            <span className="wiz-step__dot" aria-hidden="true">{state === 'done' ? '✓' : i + 1}</span>
            <span className="wiz-step__title">{title}<span className="sr-only">{state === 'done' ? ' (erledigt)' : ''}</span></span>
          </li>
        );
      })}
    </ol>
  );
}

/** Hinweiskasten eines Schritts: sagt in einfachen Worten, worauf es hier ankommt */
export function Tip({ title, children, tone = 'info' }: { title?: string; children: ReactNode; tone?: 'info' | 'warn' }) {
  return (
    <div className={`wiz-tip wiz-tip--${tone}`} role="note">
      {title && <strong>{title}</strong>}
      <div>{children}</div>
    </div>
  );
}
